import {DEFAULT_PAGE} from "../../contstants";
import getDateRange from "../../utils/getDateRange";
import {GetSellOrders} from "../sell-orders/getSellOrders";

const FilterKioskOrders = async (perPage, filters) => {

    const page = filters.page || DEFAULT_PAGE;
    const office_id = filters.office_id || '';
    const type = filters.type || 'api_load';
    const id = filters.id || '';
    const searchInFields = filters.search_in_fields || '';
    const searchPhrase = filters.s;
    const user = searchInFields.includes('user') ? searchPhrase : '';

    const { dateFrom, dateTo } = getDateRange(filters.date);

    return await GetSellOrders({
        limit: perPage,
        offset: (page - 1) * perPage,
        type,
        office_id,
        dateFrom,
        dateTo,
        id,
        user
    });
};

export default FilterKioskOrders;
